import type { FeaturevisorInstance } from '@featurevisor/sdk';
import type { OrganizationContextSchemaT } from '../contexts/organization-context';

export const ToolsArchiveFeature = (
  sdk: FeaturevisorInstance,
  context: OrganizationContextSchemaT
) => {
  const key = 'tools-archive';

  const isEnabled = sdk.isEnabled(key, context);

  return {
    key,
    isEnabled,
  };
};
